import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CommonService } from '../../../../../core/services/common.service';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { StatePersistingService } from '../../../../../core/services/state-persisting.service';
import { UserService } from '../../../../../core/services/user.service';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../../../core/common';
import { FreightClaimDetails, FreightClaimHeader, FreightClaimItem, ICustomer, IFreightOrder, IGetOrdersInquiryBody, IOrderInquiry, IOrderInquiryDetailsLbl, IOrderInquiryLbl } from '../../../../../core/models';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { OrderService } from '../../../../../core/services/order.service';
import { FreightClaimService } from '../../../../../core/services/freight-claim.service';
import { CurrencyPipe } from '@angular/common';
import { utils } from 'protractor';
import { HelperService } from '../../../../../core/services/helper.service';


@Component({
  selector: 'app-review-open-claim-details',
  templateUrl: './review-open-claim-details.component.html',
  styleUrls: ['./review-open-claim-details.component.scss']
})
export class ReviewOpenClaimDetailsComponent implements OnInit {
  trackShipmentTabGridData: GridDataResult;
  claimItemGridLoading: boolean = false;
  loadingPDF: boolean;
  loadingExcel: boolean;
  public trackShipmentGridData: FreightClaimDetails[] = [];
  order: IFreightOrder;
  claimTypeDdlData: { name: string, value: string }[] = [];
  selectedLinesForClaim: any = [];
  fullCustomerName: string = '';
  fullShipToAddress: string = '';
  shipToAddress: ICustomer;
  claimComment: string;
  selectedClaimId: string = '5ca4366a-6d1d-4324-b8e5-d471b9fbdd68';
  claim: FreightClaimHeader;
  claimNum: string = '';
  internalNotes: string = '';
  commentToUser: string = '';
  qualityDeptEmail: string = '';
  ccEmail: string = '';
  toatlApprovedAmt: number = 0;
  isDeclineClicked: boolean = false;
  isHoldClicked: boolean = false;
  isCompleteClicked: boolean = false;
  isCommentToUserEntered: boolean = false;
  isQualityEmailValid: boolean = false;

  constructor(private orderService: OrderService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private userService: UserService,
    //public persistingService: StatePersistingService,
    private helperService: HelperService,
    private languageTranslationService: LanguageTranslationService,
    private cp: CurrencyPipe,
    private freightClaimService: FreightClaimService) {
    this.route.queryParamMap.subscribe(params => {
      this.claimNum = params.get('claimId') || 'ttt';
    });
  }

  ngOnInit() {
    this.showConf = false;
    this.claim = new FreightClaimHeader();
    this.selectedClaimId = this.freightClaimService.claimHeaderId || '-1';
    this.selectedLinesForClaim = [];
    if (this.selectedClaimId == '-1') {
      this.selectedClaimId = '5ca4366a-6d1d-4324-b8e5-d471b9fbdd68';
      this.router.navigate(['/review-open-claims']);
      return;
    }
    this.loadClaimDetails();
  }

  public loadClaimDetails(): void {
    this.claimItemGridLoading = true;
    this.freightClaimService.getMyClaimsDetailsForProcessing(this.selectedClaimId).subscribe((response) => {
      this.claimItemGridLoading = false;
      if (response) {
        console.log(response);
        this.claim = response;
        this.claim.scheduleDate = this.claim.scheduleDate ? new Date(this.claim.scheduleDate) : null;
        this.trackShipmentGridData = response.details;
        this.trackShipmentGridData.forEach((el, index) => {
          el.shipDate = el.shipDate ? new Date(el.shipDate) : null;
          el.items.forEach((item, i) => {
            this.freightClaimService.setAdditionalProps(item);
          });
          this.freightClaimService.setTotal(el);
        });

        this.internalNotes = this.claim.internalNotes;
        this.commentToUser = this.claim.commentToUser;

        this.loadClaimedItemGridData();
      }


    }, error => { this.claimItemGridLoading = false; })
  }

  public openDocument(pathName: any) {
    const body = {
      Url: pathName,
    }
    this.freightClaimService.getDocument(body).subscribe((response) => {
      if (response) {
        console.log(response);
        const blob: Blob = (response && (response as any).body)
          ? (response as any).body
          : (response as Blob);
        if (blob) {
          console.log(blob.type);
          const fileName = 'download';
          //const fileName = ((child && child.partNo) ? partNo : 'download');
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 5000);

          //const downloadLink = document.createElement('a');
          //downloadLink.href = url;
          //downloadLink.download = fileName;
          //downloadLink.click();
          //window.URL.revokeObjectURL(url);
        }
      }
    });
  }


  //#region pagination, sorting,filtering,columnReorder,columnVisibilityChange for shipment grid

  public trackShipmentGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public loadClaimedItemGridData(): void {
    this.trackShipmentTabGridData = process(this.trackShipmentGridData, this.trackShipmentGridstate);
  }

  public trackShipmentGridSortChange(sort): void {
    this.trackShipmentGridstate.sort = sort;
    this.loadClaimedItemGridData();
  }

  public trackShipmentGridPageChange({ skip, take }: PageChangeEvent): void {
    this.trackShipmentGridstate.skip = skip;
    this.trackShipmentGridstate.take;
    this.loadClaimedItemGridData();
  }

  public trackShipmentDataStateChange(state: DataStateChangeEvent): void {
    this.trackShipmentGridstate = state;
    this.loadClaimedItemGridData();
  }

  public onShipmentReorder(e: any): void {
    //not needed
    //const reorderedColumn = this.gridShipmentSettings.columnsConfig.splice(e.oldIndex, 1);
    //this.gridShipmentSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    //this.saveGrid();
  }
  public onShipmentVisibilityChange(e: any): void {
    //not needed

    //e.columns.forEach(column => {
    //  this.gridShipmentSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    //});
    //this.saveTrackShipmentGrid();
  }

  //#endregion
  //#region label declaration
  public orderDetail = {
    orderHeaderLbl: 'Order Header',
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address',
    soLbl: 'SO #',
    poLbl: 'PO #',
    shippingFromLbl: 'Shipping From',
    jobNumberLbl: 'Job Number',
    cscNameLbl: 'CSC Name',
    cscPhoneLbl: 'CSC Phone',
    OrderDateLbl: 'Order Date',
    orderDetailsLbl: 'Order Details',
    invoiceDetailsLbl: 'Invoice Details',
    trackShipmentLbl: 'Track Shipments',
    exportToPdfLbl: 'Export to PDF',
    exportToExcelLbl: 'Export to Excel',
    lineLbl: 'Line #',
    orderDateLbl: 'Order Date',
    scheduleDateLbl: 'Schedule Date',
    qtyLbl: 'Qty',
    uomLbl: 'UoM',
    itemLbl: 'Item #',
    paintLbl: 'Paint Code',
    listPriceLbl: 'Unit List Price',
    itemDescLbl: 'Item Desc',
    multiplierLbl: 'Multiplier',
    statusLbl: 'Status',
    shipDateLbl: 'Ship Date',
    invoiceNumberLbl: 'Invoice #',
    orderTypeLbl: 'Order Type',
    descriptionLbl: 'Description',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    shipFromLbl: 'Ship From',
    shipmentIdLbl: 'Shipment ID',
    carrierLbl: 'Carrier',
    proNoLbl: 'Pro No.',
    billOfLading: 'Bill Of Lading',
    noOfBoxesLbl: 'No.Of Boxes',
    totalWeightLbl: 'Total Weight',
    totalPriceLbl: 'Total Price',
    grossAmountLbl: 'Gross Amount',
    taxableAmountLbl: 'Taxable Amount',
    invoiceDateLbl: 'Invoice Date',
    openAmountLbl: 'Open Amount',
    taxLbl: 'Tax',
    nonTaxableLbl: 'Non-Taxable Amount',
    kdRefLbl: 'KD Reference Number',
    customerNumberLbl: 'Customer Number',
    relatedInvoiceLbl: 'Related Invoices',
    customerNameLbl: 'Customer Name',
  };

  orderDetailTxt: IOrderInquiryDetailsLbl = {
    orderHeaderLbl: '',
    billingAddressLbl: '',
    shippingAddressLbl: '',
    soLbl: '',
    poLbl: '',
    shippingFromLbl: '',
    jobNumberLbl: '',
    OrderDateLbl: '',
    orderDetailsLbl: '',
    invoiceDetailsLbl: '',
    trackShipmentLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    lineLbl: '',
    orderDateLbl: '',
    scheduleDateLbl: '',
    qtyLbl: '',
    uomLbl: '',
    itemLbl: '',
    paintLbl: '',
    listPriceLbl: '',
    itemDescLbl: '',
    multiplierLbl: '',
    statusLbl: '',
    shipDateLbl: '',
    invoiceNumberLbl: '',
    orderTypeLbl: '',
    descriptionLbl: '',
    unitPriceLbl: '',
    extendedPriceLbl: '',
    shipFromLbl: '',
    shipmentIdLbl: '',
    carrierLbl: '',
    proNoLbl: '',
    billOfLading: '',
    noOfBoxesLbl: '',
    totalWeightLbl: '',
    cscNameLbl: '',
    cscPhoneLbl: '',
    totalPriceLbl: '',
    grossAmountLbl: '',
    taxableAmountLbl: '',
    invoiceDateLbl: '',
    openAmountLbl: '',
    taxLbl: '',
    nonTaxableLbl: '',
    kdRefLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
    relatedInvoiceLbl: '',
  }

  public trackShipmentTabGridColumnLbl = {
    shipmentId: 'Shipment ID',
    carrier: 'Carrier',
    proNo: 'Pro No.',
    billOfLoading: 'Bill Of Loading',
    noOfBoxes: 'No. Of Boxes',
    totalWeight: 'Total Weight',
    shipDate: 'Ship Date'
  };
  //#endregion
  //#region Grid Settings 
  public gridShipmentSettings: GridSettings = {
    state: this.trackShipmentGridstate,
    gridData: process(this.trackShipmentGridData, this.trackShipmentGridstate),
    columnsConfig: [{
      field: 'shipmentId',
      title: this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl,
      filterable: true
    },
    {
      field: 'carrier',
      title: this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl,
      filterable: true
    },
    {
      field: 'proNo',
      title: this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl,
      filterable: true
    },
    {
      field: 'billOfLading',
      title: this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading,
      filterable: true
    },
    {
      field: 'noOfBoxes',
      title: this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl,
      filterable: true
    },
    {
      field: 'totalWeight',
      title: this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl,
      filterable: true
    },
    {
      field: 'shipDate',
      title: this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    }
    ]
  };
  //#endregion


  goBack() {
    this.router.navigate(['/review-open-claims']);
  }

  getParentShipmentDetails(claimDetailId) {
    let shipment = this.trackShipmentGridData.find(x => x.claimDetailId == claimDetailId);
    return shipment;
  }

  //#region
  handleClaimQuantityChange(event, dataItem) {
    let count = event ? event : 0;
    dataItem.approvedQuantity = count;
    this.freightClaimService.setAdditionalProps(dataItem);
    if (count > 0) {
      this.selectedLinesForClaim = this.selectedLinesForClaim.filter(x => !(x.claimItemId == dataItem.claimItemId));
      this.selectedLinesForClaim.push(dataItem);
    }
    else if (count == 0) {
      //remove the item from the selection
      this.selectedLinesForClaim = this.selectedLinesForClaim.filter(x => !(x.claimItemId == dataItem.claimItemId));
    }

    this.trackShipmentGridData.forEach((el, index) => {
      this.freightClaimService.setTotal(el);
    });
    this.isClaimUpdateValid();
  }
  onCustomerCommentChange(event) {
    this.isClaimUpdateValid();
  }
  onQualityEmailFieldChange(event) {
    console.log("quality email changed");
    this.isClaimUpdateValid();
  }

  async declineTransferToQualityClaim() {
    let status = 'TRANSFER_TO_QUALITY_CLAIM';
    this.resetFlags();
    this.isDeclineClicked = true;
    if (this.isClaimUpdateValid()) {
      await this.updateClaim(status);
    }
  }
  async holdClaim() {
    let status = 'ONHOLD';
    this.resetFlags();
    this.isHoldClicked = true;
    if (this.isClaimUpdateValid()) {
      await this.updateClaim(status);
    }
  }
  async completeClaim() {
    this.resetFlags();
    this.isCompleteClicked = true;
    if (this.isClaimUpdateValid()) {
      await this.updateClaim('Complete');
    }
  }



  async updateClaim(status: string) {
    this.showConf = false;
    let claim = new FreightClaimHeader();
    claim.statusName = status;
    claim.claimHeaderId = this.claim.claimHeaderId;
    claim.details = [];
    claim.commentToUser = this.commentToUser;
    claim.internalNotes = this.internalNotes;
    claim.qualityDeptEmail = this.qualityDeptEmail;
    claim.ccEmail = this.ccEmail;
    claim.updatedBy = this.userService.readUserObject.userId;
    claim.raisedByUserEmail = this.claim.raisedByUserEmail;
    claim.claimNumber = this.claim.claimNumber;
    let claimDetails: FreightClaimDetails;
    let claimedItem: FreightClaimItem;
    this.selectedLinesForClaim.forEach((el, index) => {
      let shipment = this.getParentShipmentDetails(el.claimDetailId);
      if (shipment) {
        //check if details already added or not
        let dIndex = claim.details.findIndex(x => x.claimDetailId == shipment.claimDetailId)
        if (dIndex < 0) {
          claimDetails = new FreightClaimDetails();
          claimDetails.claimDetailId = el.claimDetailId;
          claimDetails.items = [];
          claim.details.push(claimDetails);
        }
        claimedItem = new FreightClaimItem();
        claimedItem.claimDetailId = el.claimDetailId;
        claimedItem.claimItemId = el.claimItemId;
        claimedItem.approvedQuantity = el.approvedQuantity
        claimedItem.approvedValue = el.approvedValue; 
        claimDetails.items.push(claimedItem);
      }
    });

    console.log(claim);

    this.freightClaimService.updateClaim(claim).subscribe((response) => {
      console.log(response);
      this.showConf = true;
    },
      (error) => {
        console.log(error);
      }
    );
  }
  resetFlags() {
    this.isDeclineClicked = false;
    this.isCompleteClicked = false;
    this.isHoldClicked = false;
  }
  isClaimUpdateValid() {
    let isValid: boolean = true;
    this.isCommentToUserEntered = true;
    this.isQualityEmailValid = true;
    if (this.isCompleteClicked || this.isDeclineClicked) {
      if (!(this.commentToUser && this.commentToUser.trim().length > 0)) {
        this.isCommentToUserEntered = false;
        isValid = false;
      }
    }
    if (this.isDeclineClicked) {
      if (!(this.qualityDeptEmail && this.qualityDeptEmail.trim().length > 0)) {
        this.isQualityEmailValid = false;
        isValid = false;
      }
      if (!(this.qualityDeptEmail && this.helperService.validateEmail(this.qualityDeptEmail))) {
        this.isQualityEmailValid = false;
        isValid = false;
      }
    }
    return isValid;
  }
  //#endregion

  showConf: boolean = false;

  closeConfirmDialog() {
    this.showConf = false;
    this.router.navigate(['/review-open-claims']);
  }



}
